import React, { Component } from "react";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { BuyerInfo, ENocMollakData, Mode } from "../../enocapi/entities";
import { Redirect } from "react-router";
import PageContent from "@my-dld/components/PageContent";
import { extractPropInfo } from "../MyDLD/PropertyDetails";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import { LocaleUtil } from "@eres/core";
import { BaseTabuRequestProps } from "../TabuRequest/BaseTabuRequestForm";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import BuyerDetails from "./BuyerDetails";
import BuyerList from "./BuyerList";

type ENocComponent<P, S> = React.ComponentClass<P, S>

export interface IENocComponent<P, S> extends Component<P, S> {
}

export enum EnocTrackIndex {
	BUYER_LIST = 0,
	BUYER_DETAILS = 1,
}

export interface IENocTrack {
	index: number;
	name: LocaleValue;
	screen: ENocComponent<any, any>;
	form: any;
}

let ENocTrack: IENocTrack[] = [
	{
		index: 0,
		name: LVStrings.buyers,
		screen: BuyerList,
		form: React.createRef<IENocComponent<any, any>>(),
	},
	{
		index: 1,
		name: LVStrings.buyer_details,
		screen: BuyerDetails,
		form: React.createRef<IENocComponent<any, any>>(),
	}
];

interface Props extends RoutedViewProps {
}

export interface ENocMollakProps extends BaseTabuRequestProps {
	holder: any;
	property: AssetCard;
	onPrevious: ( index: number ) => void;
	onNext: ( index: number ) => void;
	setData: ( buyer: BuyerInfo, position: number, callBack?: () => void ) => void;
	getData: ( position?: number ) => any;
	setIndex: ( position: number, callBack?: () => void ) => void;
	getIndex: () => number;
	getBuyers: () => BuyerInfo[];
	getENocData: () => ENocMollakData;
	getTabuProperty: () => AssetCard;
}

interface State {
	current: IENocTrack;
	eNOCModel: Partial<ENocMollakData>;
	buyers: BuyerInfo[];
	currentBuyerIndex: number;
	property: AssetCard;
}

export default class ENocMollak extends Component<Props, State> {

	constructor( props: Props ) {
		super( props );
		const eNOCModel = props.location.state ? props.location.state.eNOCModel : undefined;
		const buyers = ( props.location.state && props.location.state.buyers ) ? props.location.state.buyers : [];
		const property = ( props.location.state && props.location.state.property ) ? props.location.state.property : [];
		this.state = {
			current: ENocTrack[ 0 ],
			eNOCModel: eNOCModel,
			buyers: buyers,
			currentBuyerIndex: -1,
			property: property,
		};
		this.setData = this.setData.bind( this );
		this.getData = this.getData.bind( this );
		this.getIndex = this.getIndex.bind( this );
		this.setIndex = this.setIndex.bind( this );
		this.getBuyers = this.getBuyers.bind( this );
		this.getENocData = this.getENocData.bind( this );
		this.getTabuProperty = this.getTabuProperty.bind( this );
	}

	render() {
		const { current, eNOCModel } = this.state;
		const property = this.props.location.state ? this.props.location.state.property : undefined;
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		const { val, lbl } = extractPropInfo( property );
		return <>
			<PageContent
				title={ `${ Strings.enoc_request } - ${ lbl } : ${ val }` }
				hideQLinks={ true }>
				<PageTitle title={ Strings.enoc_request } paths={ [ DashboardBCItem ] }/>
				<div>
					{ current && <div id={ "tr" + current.index } key={ "IENocTrack" + current.index } className="tender-registration-form">
						{
							eNOCModel.mode != Mode.VIEW &&
							<div className="content-section">
								<div className="content-section-title">
									<span className="section-title-span">{ LocaleUtil.getLocalValue( current.name ) }</span>
									{
										current.index === 0 && eNOCModel.mode === Mode.CREATE &&
										<>
											<button
												className="btn btn_1 btn_style1 btn-sm" data-bs-target="#completedProjectsModal"
												onClick={ () => {
													this.setIndex( -1, () => {
														this.onNext( EnocTrackIndex.BUYER_DETAILS );
													} );
												} }
												data-bs-toggle="modal" type="button">
												<i className="fa fa-plus"></i> { Strings.add_buyer }
											</button>
										</>
									}
								</div>
							</div>
						}
						<this.state.current.screen
							holder={ this }
							{ ...this.props }
							property={ property }
							onPrevious={ this.onPrevious }
							setData={ this.setData }
							getData={ this.getData }
							getIndex={ this.getIndex }
							setIndex={ this.setIndex }
							getBuyers={ this.getBuyers }
							getENocData={ this.getENocData }
							getTabuProperty={ this.getTabuProperty }
							onNext={ this.onNext }/>
					</div> }
				</div>
			</PageContent>
		</>;
	}

	setData( buyer: BuyerInfo, position: number, callBack?: () => void ) {
		let m = this.state.buyers;
		if ( position < 0 ) {
			if ( this.state.buyers.length > 0 ) {
				let lastBuyer = this.state.buyers[ this.state.buyers.length - 1 ];
				buyer.index = lastBuyer.index!++;
			} else {
				buyer.index = 0;
			}
			m.push( buyer );
		} else {
			m[ position ] = buyer;
		}
		this.setState( { buyers: m }, callBack );
	}

	getData( position: number ): BuyerInfo {
		return this.state.buyers[ position ];
	}

	getBuyers(): BuyerInfo[] {
		return this.state.buyers;
	}

	getIndex(): number {
		return this.state.currentBuyerIndex;
	}

	setIndex( position: number, callBack?: () => void ) {
		this.setState( { currentBuyerIndex: position }, callBack );
	}

	getENocData(): ENocMollakData {
		return this.state.eNOCModel;
	}

	getTabuProperty(): AssetCard {
		return this.state.property;
	}

	private onPrevious = ( index: number ) => {
		if ( index > 0 ) {
			this.setState( { current: ENocTrack[ index - 1 ] } );
		} else {
			this.setState( { current: ENocTrack[ 0 ] } );
		}
	};

	private onNext = ( index: number ) => {
		if ( index === ( ENocTrack.length - 1 ) ) {
			this.setState( { current: ENocTrack[ index ] } );
		}
	};

}
